import {html, css, LitElement} from 'lit';

export class DzCompactSearch extends LitElement {

    static get properties() {
        return {
            minLength:   { type: Number },
            collapsed:   { type: Boolean },
            searchclass: { type: String }
        }
    }

    constructor() {
        super()
        this.index = new FlexSearch.Index({
            preset: "memory",
            tokenize: "forward",
            resolution: 3
        })
        this.minLength = 8
        this.collapsed = false
    }

    connectedCallback() {
        super.connectedCallback()
        
        for (let [n, item] of this.querySelectorAll(`*[searchitem=${this.searchclass}]`).entries()) {
            let text = [...item.querySelectorAll(`*[searchtext=${this.searchclass}]`)].map(node => node.innerText).join(",")
            this.index.add(n, text)
            item.setAttribute("slot", "found")
        }

        this.addEventListener("find", evt => {        
            for (let item of this.querySelectorAll(`*[searchitem=${this.searchclass}]`)) {
                item.setAttribute("slot", "")
            }
            for (let match of this.index.search(evt.detail)) {
                this.children[match + 1].setAttribute("slot", "found")
            }
            evt.stopPropagation()
        })

        this.addEventListener("expand", evt => {
            this.collapsed = false
            this.displayNodes(Number.MAX_VALUE)
        })

        this.addEventListener("reset", evt => {
            this.displayNodes(Number.MAX_VALUE)
            evt.stopPropagation()
        })

        if (this.collapsed) {
            this.displayNodes(this.minLength)
        }

    }

    displayNodes(max_count) {
        let n = 0
        for (let item of this.querySelectorAll(`*[searchitem=${this.searchclass}]`)) {
            if (n < max_count) {
                item.setAttribute("slot", "found")
            } else {
                item.setAttribute("slot", "")
            }
            n = n + 1
        }
    }

    render() {
        let result = []

        if (!this.collapsed) {
            result.push(html`<slot name="panel"></slot>`)
        }
        
        result.push(html`<slot name="found" part="found"><span class="not-found">Не найдено</span></slot>`)

        if (this.collapsed) {
            result.push(html`
                <dz-custom-event name="expand">
                    <button class="expand-btn">Показать все</button>
                </dz-custom-event>
            `)
        }


        return html`${result}`
    }


    static get styles() {
        return css`

            slot[name=found] {
                display: block;
                padding-left: 5px;
                max-height: 300px;
                overflow-y: auto;
            }

            *[part="found"]::-webkit-scrollbar {
                width: 8px;
            }

            *[part="found"]::-webkit-scrollbar-thumb {
                margin: 3px;
                background: #0001;
                border-radius: 20px;
            }

            *[part="found"]::-webkit-scrollbar-thumb:hover {
                background: #0003;
            }

            .not-found {
                display: flex;
                width: 100%;
                padding: 20px;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
            }

            .expand-btn {
                width: 100%;
                border: solid #0001 1px;
                padding: 5px;
                margin-top: 10px;
                border-radius: 5px;
            }
        `}



}

customElements.define('dz-compact-search', DzCompactSearch)